import { createFileRoute } from "@tanstack/react-router";
import Nosotros from "../pages/Nosotros";

export const Route = createFileRoute("/nosotros")({
  head: () => ({
    meta: [
      { title: "Nosotros — Menos humo, más resultados | CreceLocal" },
      {
        name: "description",
        content:
          "Conocé al equipo de CreceLocal: sistemas de marketing accesibles y sin vueltas para empresas de servicios y distribuidores. Equipo, valores, seguridad y confianza.",
      },
      {
        property: "og:title",
        content: "Nosotros — Menos humo, más resultados | CreceLocal",
      },
      {
        property: "og:description",
        content:
          "Conocé al equipo de CreceLocal: sistemas de marketing accesibles y sin vueltas para empresas de servicios y distribuidores. Equipo, valores, seguridad y confianza.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: Nosotros,
});
